import ExcelModal from '@/views/parametres/import-excel-modal'
import $ from 'jquery'

export default {
    name: 'tarif-consommable',
    components: {
        ExcelModal
    },
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_consommable_tarif_data: Object
    },
    data() {
        return {
            is_printing: false,
            consommable_is_loading: true,
            consommable_is_empty: false,
            is_error_load: false,

			consumable_filter: "",
			perPage: 20,
			print_per_page: -1,
			currentPage: 1,
            can_print: false,

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,
        }
    },

    watch: {
        assurance_select() {
            const data = {
                assurance_id: this.assurance_select.compagnie_id,
                data_type: 'consommable'
            }
            this.getListeConsommables(data)
        },

        editing_consommable_tarif_data() {
            this.saveTarifConsommable()
        }
    },

    computed: {
        tarif_consommables() {
            return this.$store.getters["tarif_consommables"];
        },

        consommable_length() {
            return this.tarif_consommables.length;
        },
    },

    mounted() {
        const data = {
            assurance_id: 0,
            data_type: 'consommable'
        }
        this.getListeConsommables(data)
    },

    methods: {
        getListeConsommables(data) {
            this.consommable_is_loading = true

            this.$store.dispatch('getTarifConsommable', data).then(() => {
                if (this.tarif_consommables.length > 0) {
                    this.consommable_is_empty = false
                } else {
                    this.consommable_is_empty = true
                }
                this.consommable_is_loading = false
            }).catch(() => {
                this.consommable_is_loading = false
                this.is_error_load = true
            })
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifConsommable', tarif_data)
        },

        saveTarifConsommable() {
            this.editing_consommable_tarif_data.type_prestation = 'consommable'
            this.$store.dispatch("saveTarifArticle", this.editing_consommable_tarif_data).then((response) => {
                if (response.success) {
                    const data = {
                        assurance_id: this.assurance_select.compagnie_id,
                        data_type: 'consommable'
                    }
                    this.getListeConsommables(data)

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        printTarifConsumable() {
            const data = {
                data_type: 'consommable',
                prestations: this.tarif_consommables
            }
            
            this.$emit('emitPrintTarif', data)
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListeConsommable'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);       
        },
    }
}
